module.exports = __webpack_public_path__ + "static/img/DashcamBg.afa48cc.png";


//////////////////
// WEBPACK FOOTER
// ./static/bg/DashcamBg.png
// module id = bWIT
// module chunks = 1